module.exports = __webpack_public_path__ + "media/images/lb/472-9ea2634e17ba65e86e7d9b0d7db14a9a.svg";